// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.addSession_selectRepeatInterval{
    width: 80px;
}

.addSession_repeatCustom{
    display: flex;
    flex-direction: column;
    gap: 5px;
    padding: 5px;
    padding-left: 10px;
    padding-bottom: 0;
}

.addSession_repeatCustom--inactive{
    opacity: 0.3;
    pointer-events: none;
}

.addSession_formItem_content .commonDropDown--opened {
    z-index: 10;
}

.addSession_formItem_content .commonDropDown--opened .commonDropDown_wrap {
    z-index: 10;
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/sessions/addSession/RepeatOptionsForm.css"],"names":[],"mappings":";AACA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf","sourcesContent":["\n.addSession_selectRepeatInterval{\n    width: 80px;\n}\n\n.addSession_repeatCustom{\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n    padding: 5px;\n    padding-left: 10px;\n    padding-bottom: 0;\n}\n\n.addSession_repeatCustom--inactive{\n    opacity: 0.3;\n    pointer-events: none;\n}\n\n.addSession_formItem_content .commonDropDown--opened {\n    z-index: 10;\n}\n\n.addSession_formItem_content .commonDropDown--opened .commonDropDown_wrap {\n    z-index: 10;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
